import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";
import { microActivityList, microActivityUniqueList, microActivity_csv_export} from "constants/microActivity";

export const getMicroActivityList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.microActivity_list(pageNum, filters);
    dispatch({ type: microActivityList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: microActivityList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getMicroActivityUniqueList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.microActivity_unique_list(pageNum, filters);
    console.log("micro activity response", res?.data);
    dispatch({ type: microActivityUniqueList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: microActivityUniqueList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const addMicroActivity = async (bodyData) => {
  try {
    const res = await api.add_microActivity(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const editMicroActivity = async (id, bodyData) => {
  try {
    const res = await api.edit_microActivity(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getMicroActivityDetailsById = async (id) => {
  try {
    const res = await api.get_microActivity_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteMicroActivity = async (id) => {
  try {
    const res = await api.delete_microActivity_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const importMicroActivity = async (fileData) => {
  try {
    const res = await api.import_microActivity(fileData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};


export const exportMicroActivityData = async (filtersJSON) => {
  try {
    const res = await api.microActivity_csv_export(filtersJSON) // correct call
    return res;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};